module.exports = __webpack_public_path__ + "static/media/bitcoinorange.36aa0781.svg";